var ezdia;
(function (ezdia) {
    function quickActionSeletedId(_a) {
        var count = _a.count, _b = _a.text, text = _b === void 0 ? '' : _b, _c = _a.btnId, btnId = _c === void 0 ? 'ez-js-copy-field-btn' : _c, _d = _a.inputboxId, inputboxId = _d === void 0 ? 'ez-js-copy-field' : _d, _e = _a.btnTitle, btnTitle = _e === void 0 ? 'Copy all ids' : _e;
        return "\n      <div class=\"quick-action-id-form-view\">\n        <b>" + (count || '') + "</b> Selected Ids:  <span>" + text + "</span>\n          <button id=\"" + btnId + "\" data-button=\"copy\" type=\"button\" class=\"btn btn-link copy-ids\" title=\"" + btnTitle + "\"><i class=\"fa fa-copy\"></i></button>\n      </div>\n      <input class=\"copy-text-box\" type=\"text\" id=\"" + inputboxId + "\" value=\"" + text + "\" />\n    ";
    }
    function getQAItemContent(qaItems, itemObject, viewType, isShadow) {
        var selectedID = qaItems.selectedID;
        var _a = itemObject.min, min = _a === void 0 ? 0 : _a, _b = itemObject.max, max = _b === void 0 ? '' : _b, id = itemObject.id, label = itemObject.label, type = itemObject.type, field = itemObject.field, actionUrl = itemObject.actionUrl;
        var idAttr = '';
        if (id) {
            if (isShadow) {
                idAttr = "data-id=\"ez-quick-link-" + id + "\"";
            }
            else {
                idAttr = "id=\"ez-quick-link-" + id + "\"";
            }
        }
        return "\n    <a\n      " + (viewType === 'button' ? 'class="btn btn-default"' : '') + "\n      data-view-type=\"" + viewType + "\"\n      data-actionurl=\"" + actionUrl + "\"\n      data-label=\"" + encodeURIComponent(label) + "\"\n      data-dd=\"" + selectedID + "\"\n      data-min=\"" + min + "\"\n      data-max=\"" + max + "\"\n      href=\"javascript:void(0)\"\n      " + idAttr + "\n      data-type=\"" + type + "\"\n      data-name=\"" + (field || '') + "\"\n      >" + label + "</a>";
    }
    function genQAItem(qaItems, isShadow) {
        var e_1, _a;
        var links = qaItems.links;
        var linkItems = [];
        try {
            for (var links_1 = __values(links), links_1_1 = links_1.next(); !links_1_1.done; links_1_1 = links_1.next()) {
                var link = links_1_1.value;
                linkItems.push("\n      <li>" + getQAItemContent(qaItems, link, 'dd', isShadow) + "</li>");
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (links_1_1 && !links_1_1.done && (_a = links_1.return)) _a.call(links_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return linkItems.join('');
    }
    function getButtons(qaItems, isShadow) {
        var e_2, _a;
        var btns = qaItems.btns;
        var linkItems = [];
        try {
            for (var btns_1 = __values(btns), btns_1_1 = btns_1.next(); !btns_1_1.done; btns_1_1 = btns_1.next()) {
                var link = btns_1_1.value;
                linkItems.push("" + getQAItemContent(qaItems, link, 'button', isShadow));
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (btns_1_1 && !btns_1_1.done && (_a = btns_1.return)) _a.call(btns_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return linkItems.join('');
    }
    function getMarkup(qaItems, isShadow) {
        var qaId = qaItems.id, selectedID = qaItems.selectedID;
        var linkItems = genQAItem(qaItems, isShadow);
        var ddContent = '';
        if (linkItems) {
            ddContent = "<button\n        data-toggle=\"dropdown\"\n        type=\"button\"\n        class=\"btn btn-default dropdown-toggle\"\n      >\n        <span id=\"" + (!isShadow ? selectedID : '') + "\">More</span>\n        <span class=\"caret\"></span>\n      </button>\n      <ul class=\"dropdown-menu dropdown-menu-right quick-actions-dropdown-menu\" role=\"menu\" style=\"max-height: 250px; overflow: auto\">\n        " + linkItems + "\n      </ul>";
        }
        var htmlContent = "" + getButtons(qaItems, isShadow) + ddContent;
        if (isShadow) {
            return htmlContent;
        }
        return "<div id=\"" + qaId + "\" class=\"btn-group btn-group-sm quick-actions-btn-dd\" data-quick-action-dd=\"button\">\n      " + htmlContent + "\n    </div> ";
    }
    function confirmChangesMsg(_a) {
        var ids = _a.ids, allIds = _a.allIds, idsCount = _a.idsCount, isMany = _a.isMany, textBoxId = _a.textBoxId, copyBtnId = _a.copyBtnId;
        var manyIdsContent = '';
        if (isMany) {
            manyIdsContent = "<button type=\"button\" class=\"btn btn-link btn-sm\">Show More</button></span>\n        <span id=\"ezdia-cc-id-more\" data-container=\"more\" style=\"display: none\">\n        " + allIds.join(', ') + "\n        <button type=\"button\" class=\"btn btn-link btn-sm\">Show Less</button>\n      ";
        }
        return "<input class=\"copy-text-box\" type=\"text\" id=\"" + textBoxId + "\" value=\"" + allIds + "\">\n    <p>Are you sure you want to update " + idsCount + " items? Once you confirm, you will not be able to undo the changes made.</p>\n    <p class=\"confirm-changes-msg\">\n      The following ids will be updated: <br>Ids:\n      <span id=\"ezdia-cc-id-less\" data-container=\"less\">\n        " + ids.join(', ') + manyIdsContent + "\n      </span>\n      <button id=\"" + copyBtnId + "\" type=\"button\" class=\"btn btn-link copy-ids\" title=\"Copy all ids\"><i class=\"fa fa-copy\"></i></button>\n    </p>\n    ";
    }
    function getAssignmentList(assignmentList) {
        var btn = "<button data-toggle=\"dropdown\" type=\"button\" class=\"btn btn-default btn-sm dropdown-toggle\">Assignment List\n      <span class=\"caret\"></span>\n    </button>";
        var items = assignmentList
            .map(function (_a) {
            var name = _a.name, label = _a.label;
            return "<li id=\"assignment_" + name + "\">\n        <a href=\"javascript:void(0)\" data-name=\"" + name + "\">" + label + "</a>\n      </li>";
        })
            .join('');
        return "<div class=\"ez-grid-action-btns-group\">\n      " + btn + "<ul id=\"ez-assignment-list-grid\" class=\"dropdown-menu dropdown-menu-right\">\n        " + items + "\n      </ul>\n    </div>";
    }
    function checkout() {
        return "<div class=\"ez-grid-action-btns-group\">\n      <a id=\"ez_js__grid__check-out\" class=\"btn btn-default\" data-view-type=\"button\" href=\"javascript:void(0)\" >Check out</a>\n    </div>";
    }
    var templates;
    (function (templates) {
        templates.quickActions = {
            getMarkup: getMarkup,
            genQAItem: genQAItem,
            quickActionSeletedId: quickActionSeletedId,
            confirmChangesMsg: confirmChangesMsg,
            getAssignmentList: getAssignmentList,
            checkout: checkout
        };
    })(templates = ezdia.templates || (ezdia.templates = {}));
})(ezdia || (ezdia = {}));
